import Loadable from 'react-loadable';

const LoadableMyClientsGroupedContainer = Loadable({
  loader: () =>
    import(/* webpackChunkName: "myClientsGroupedContainer" */ './index'),
  loading: () => null,
});

export default LoadableMyClientsGroupedContainer;
